import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { Post } from '../../interfaces/post.interface';
import { UserThumbNailComponent } from '../user-thumb-nail/user-thumb-nail.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-user-details-dialog',
    templateUrl: './user-details-dialog.component.html',
    styleUrl: './user-details-dialog.component.scss',
    imports: [UserThumbNailComponent, CdkScrollable, MatDialogContent, AssetUrlPipe]
})
export class UserDetailsDialogComponent {
  dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<UserDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Post
  ) { }

  ngOnInit() {
    this.dialogData = this.data;
  }
  close() {
    this.dialogRef.close(false);
  }
}
